import React from 'react';
import { Button } from '../ui/Button';
import { PlayCircle } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-20 pb-16 px-4 md:pt-28 md:pb-24 max-w-5xl mx-auto text-center" data-id="element-94">
      <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-tight mb-8" data-id="element-95">
        Aprendé a Editar Videos Profesionales En 7 Días y
        <br data-id="element-96" />
        <span className="text-blue-400" data-id="element-97">Generá +$1000 USD</span>
        <br data-id="element-98" />
        <span className="text-blue-400" data-id="element-99">Extra al Mes</span>
      </h1>

      {/* VSL Video Player Placeholder */}
      <div className="relative w-full max-w-4xl mx-auto aspect-video bg-slate-900 rounded-2xl shadow-2xl overflow-hidden mb-8 group cursor-pointer border border-slate-800" data-id="element-100">
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-101">
          <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-blue-600/50" data-id="element-102">
            <PlayCircle className="w-10 h-10 text-white ml-1" data-id="element-103" />
          </div>
        </div>
        <div className="absolute bottom-4 left-4 right-4 text-left" data-id="element-104">
          <p className="text-white/80 text-sm font-medium" data-id="element-105">
            Haz clic para reproducir el video
          </p>
        </div>
      </div>

      <p className="text-lg md:text-xl text-slate-400 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-106">
        Un método práctico para transformar la edición en una habilidad rentable
        y aplicable a clientes reales, aunque hoy no sepas por dónde empezar,
        sin experiencia previa ni equipos caros.
      </p>

      <Button href="https://brunocairo.com/checkouts/cn/hWN9d9LNaqEHoVMgvxz2ena6/es-ar?_r=AQABm5dgdg20OJYxL1tr8gcCs9ZD5-sayP96XU9opQQ6yDg&preview_theme_id=156155707625" size="xl" className="w-full md:w-auto md:px-12 animate-pulse-slow" data-id="element-107">
        Quiero acceder al curso ahora
      </Button>
    </section>;
}